
import React from "react";

/* */

const Section = (props) => {
    return (
        <div className="text-center">
            <div className="mt-4"><h3>{props.title}</h3></div>
            <div className="mb-5 text-muted"><h4>{props.message}</h4></div>
            <div className={"mb-6 section-title-border " + props.className}></div>
        </div>
    );
}

export default Section;    